import React from "react"

interface DtmfKeypadSequenceProps {
  digits: string[]
  className?: string
}

/** Renders DTMF presses as one compact chip of keypad digits. */
export const DtmfKeypadSequence: React.FC<DtmfKeypadSequenceProps> = ({
  digits,
  className = "",
}) => (
  <div
    role="img"
    aria-label={`Keys pressed: ${digits.join(" ")}`}
    // One text node, not a span per digit, so a triple-click selects the
    // whole sequence and copying yields "1 2 3".
    className={`inline-block max-w-full rounded bg-coval-text/5 px-1.5 py-0.5 font-mono text-xs leading-4 text-coval-text ${className}`}
  >
    {digits.join(" ")}
  </div>
)
